import { IACDLEvent } from '../../../../__legacy__/services/eventBus.service';

export const AttachmentRenamedEventType = Symbol('ATTACHMENT_RENAMED_EVENT');

export class AttachmentRenamedEvent implements IACDLEvent {
  readonly type: symbol = AttachmentRenamedEventType;
}
